import { render, staticRenderFns } from "./EditRates.vue?vue&type=template&id=1fc04ee8&scoped=true&"
import script from "./EditRates.vue?vue&type=script&lang=js&"
export * from "./EditRates.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=1fc04ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc04ee8",
  null
  
)

export default component.exports